import 'bootstrap/dist/css/bootstrap.min.css'
import React from 'react'
import { connect } from 'react-redux'
import { userActions } from '../actions/userActions'
import { Link } from 'react-router-dom'
import Footer from './Footer'
import PerfectScrollbar from 'react-perfect-scrollbar'
import './../css/base.css'
import './../helpers/importCSS'
import logo from './../img/ab_logo4.png'
import products from './../img/products.png'
import warranty from './../img/warranty.png'
import news from './../img/promo.png';
import alliance from './../img/alliance.png';
import partner from './../img/partner.png';
import links from './../img/links.png';

import ErrorBoundary from '../ErrorBoundary'
import Navbar from './Navbar'

class Template extends React.Component {
  constructor (props) {
    super(props)
    this.clickLogOut = this.clickLogOut.bind(this)
    this._scrollBarRef = React.createRef()
  }

  clickLogOut () {
    this.props.logout()
  }

  render () {
    const { user } = this.props
    const { alert } = this.props

    return <>
      <header>
        <Navbar clickLogOut={this.clickLogOut} mfgId={user.addr} />
      </header>
      <main>
        <ErrorBoundary>
          {alert.message &&
            <div className={`alert ${alert.type}`} dangerouslySetInnerHTML={{ __html: alert.message }} />}
          {this.props.children}
        </ErrorBoundary>
      </main>
      <Footer />
    </>
  }
}

const mapState = (state) => {
  const { alert, user } = state
  return { alert, user }
}

const actionCreators = {
  logout: userActions.logout
}

export default connect(mapState, actionCreators)(Template)
